import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	me: null,
};

const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setUser: (state, action) => {
			if (action.payload) {
				state.me = action.payload.user;
			}
		},
		resetUser: (state) => {
			state.me = initialState.me;
		},
	},
});

export default userSlice.reducer;
export const { setUser, resetUser } = userSlice.actions;

export const selectMe = (state) => state.user.me;
